export const PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_REQUEST =
  'profile/employer-company-logo-remove-request'
export const PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_SUCCESS =
  'profile/employer-company-logo-remove-success'
export const PROFILE_EMPLOYER_COMPANY_LOGO_REMOVE_FAILED =
  'profile/employer-company-logo-remove-failed'
